import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {EditProfileFormValues} from "../../../components/form/Form-edit-profile";


interface EditProfileState {
    values: EditProfileFormValues;
    loading: boolean;
    success:boolean;
    errors: {
        [key: string]: string[];
    };
    error: string | null;
}

const initialState: EditProfileState = {
    values: {
        firstName: '',
        lastName: '',
        phone: '',
        additionalPhone: '',
        email: '',
        birthDate: '',
        timeZone: '',
        country: '',
        address: '',
        currency:'',
        vk:'',
        telegram:'',
        viber:'',
        whatsapp:'',
        instagram:'',
        facebook:'',
    },
    loading: false,
    errors: {},
    error: '',
    success:false,
};

const editProfileSlice = createSlice({
    name: 'editProfile',
    initialState,
    reducers: {
        setEditProfileValues: (state, action: PayloadAction<EditProfileFormValues>) => {
            state.values = action.payload;
        },
        editProfileRequest: (state) => {
            state.loading = true;

        },
        editProfileSuccess: (state) => {
            state.loading = false;
        },
        clearEditProfileErrors: (state,action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>)  => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = action.payload.success;
        },
    },
});

export const {
    setEditProfileValues,
    editProfileRequest,
    editProfileSuccess,
    clearEditProfileErrors
} = editProfileSlice.actions;


export const editProfileReducer =  editProfileSlice.reducer;
